import axios from 'axios';
import { getCookie } from '../util/index';
import { logout } from '../util/index'
import _ from 'lodash'
import { getQueryVariable } from './jobInfo';

axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
const isLoginPage = document.getElementById('txtInputName');
if(!isLoginPage){
  axios.defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
}
axios.defaults.method = 'post';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  const msg = _.get(error, 'response.data.msg', null)
  if (msg === 'Expired Token' || msg === 'Expired token' || msg === 'Event not allowed without valid token') {
    if(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken' && 
    (!window.localStorage.getItem("401Reloads") || parseInt(window.localStorage.getItem("401Reloads")) < 5)){
      window.localStorage.setItem("401Reloads", (parseInt(window.localStorage.getItem("401Reloads"))||0)+1)
      window.location.reload(true);
      return;
    }

    console.error('Expired Token: ', 'Expired Token');
    // Send user to login URL
    logout();
    setTimeout(()=>{
      window.location = '/'
    },0);
  }
  return Promise.reject(error);
});

const custom = (config = {}) => {
  let eventType = config.data.eventType;
  axios.defaults.headers.common['kxToken']  = (['VALIDATE_AUTH_TOKEN','SET_AUTH_TOKEN'].includes(eventType)) ? "" : getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
  axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
  config.url = config.url || axios.defaults.baseURL + "?axd=" + config.data.eventType;
  if (eventType == "GENERATE_PDF" || eventType == "SUBMIT_ENTRY_SUMMARY_FORM") {
    let chartoAdd = config.url.indexOf('?') >= 0 ? '&' : '?';
    config.url += `${chartoAdd}timeout=100000`
  }
  return axios(config);
}

const fileUpload = (data, config = {}, shipId) => {
  axios.defaults.baseURL = `${window._env_.REACT_APP_MEDIA_URL}/${shipId}`;
  return axios(data, config);
}

const addDoc = (data, config = {}) => {
  axios.defaults.baseURL = `${window._env_.REACT_APP_BROKER_API_URL}?axd=${data.data.eventType}&timeout=35000`;
  return axios(data, config);
}

const all = (requestArray) => {
  return axios.all(requestArray)
}
const post = data => {
  let config = {}
  config.data = data
  return axios(config)
}
const get = (url = '', data = '', config = {}) => {
  config.params = data;
  config.method = "get";
  return axios.get(url, config)
}

const put = (url = '', data = '', config = {}) => {
  return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
  return axios.delete(url, config)
}

const HttpClient = {
  custom,
  post,
  get,
  put,
  delete: del,
  all,
  fileUpload,
  addDoc,
}

export { HttpClient }
